import { Theme } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    logo: {
      width: 70,
      alignSelf: 'center',
    },
  })
);

export default useStyles;
